import { RestrictedTag } from '@apis/TagManager/model';
import { Button, Stack } from '@mantine/core';
import { PagePanel } from '@root/Design/Layout';
import { useEffect, useState } from 'react';
import { RestrictedTagEditor } from './RestrictedTagEditor';
import { SidePanelContainer } from '@root/Design/SidePanel';

export interface RestrictedTagsProps {
    pageTitle?: string;
    companyId: number;
    onDone: () => void;
    onSave: (tags: RestrictedTag[]) => void;
    tagtoUpdate?: RestrictedTag;
    showCloseButton?: boolean;
    readonly?: boolean;
}
export const SaveRestrictedTags = (props: RestrictedTagsProps) => {
    const { readonly } = props;
    const [rTags, setRTags] = useState<RestrictedTag[]>([]);
    const [canRemove, setCanRemove] = useState(false);
    const [saveReady, setSaveReady] = useState(false);

    useEffect(() => {
        if (props.tagtoUpdate) {
            setRTags([props.tagtoUpdate]);
        } else {
            addRowHandler();
        }
    }, []);

    useEffect(() => {
        setCanRemove(rTags.length > 1);
    }, [rTags]);

    const addRowHandler = () => {
        setRTags((prev) => [
            ...prev,
            {
                TagName: '',
                CompanyId: props.companyId,
                Icon: { Color: 'blue', Name: 'tag' },
                Description: '',
                ClarityScore: true,
                CompletenessScore: true,
                ComplianceScore: true,
                CoverageScore: true,
                IsActive: true,
            },
        ]);
    };

    const removeRowHandler = (index: number) => {
        if (rTags.length > 1) {
            setRTags((prev) => prev.filter((_, i) => i !== index));
        }
    };

    const handleSave = () => {
        props.onSave(rTags.filter((tag) => tag.TagName !== ''));
    };

    const handleCancel = () => {
        props.onDone();
    };

    const handleUpdateTag = (index: number, updatedTag: RestrictedTag) => {
        setRTags((prev) => {
            const newTags = [...prev];
            newTags[index] = updatedTag;
            return newTags;
        });
        setSaveReady(updatedTag.TagName !== '');
    };

    return (
        <PagePanel size={500}>
            <SidePanelContainer
                title={props.pageTitle}
                onClose={() => props.onDone()}
                toolbar={
                    <>
                        <Button onClick={handleCancel} variant="outline">
                            Cancel
                        </Button>
                        <Button hidden={readonly} onClick={handleSave} disabled={!saveReady}>
                            Save
                        </Button>
                    </>
                }
            >
                {rTags.length > 0 ? (
                    <Stack>
                        {rTags.map((tag, index) => (
                            <>
                                <RestrictedTagEditor
                                    key={index}
                                    restrictedTag={tag}
                                    handleRemoveRow={removeRowHandler}
                                    canRemove={canRemove}
                                    index={index}
                                    onChange={handleUpdateTag}
                                />
                            </>
                        ))}
                    </Stack>
                ) : null}
            </SidePanelContainer>
        </PagePanel>
    );
};
